var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.14601 7.354C2.19245 7.40056 2.24763 7.43751 2.30838 7.46271C2.36912 7.48792 2.43424 7.50089 2.50001 7.50089C2.56578 7.50089 2.6309 7.48792 2.69164 7.46271C2.75239 7.43751 2.80756 7.40056 2.85401 7.354L6.00001 4.207L9.14601 7.354C9.1925 7.40049 9.24769 7.43736 9.30842 7.46252C9.36916 7.48768 9.43426 7.50063 9.50001 7.50063C9.56575 7.50063 9.63085 7.48768 9.69159 7.46252C9.75233 7.43736 9.80752 7.40049 9.85401 7.354C9.9005 7.30751 9.93737 7.25232 9.96253 7.19158C9.98769 7.13084 10.0006 7.06574 10.0006 7C10.0006 6.93426 9.98769 6.86916 9.96253 6.80842C9.93737 6.74768 9.9005 6.69249 9.85401 6.646L6.35401 3.146C6.30756 3.09944 6.25239 3.06249 6.19164 3.03729C6.1309 3.01208 6.06578 2.99911 6.00001 2.99911C5.93424 2.99911 5.86912 3.01208 5.80838 3.03729C5.74763 3.06249 5.69245 3.09944 5.64601 3.146L2.14601 6.646C2.09945 6.69244 2.0625 6.74762 2.0373 6.80837C2.01209 6.86911 1.99911 6.93423 1.99911 7C1.99911 7.06577 2.01209 7.13089 2.0373 7.19163C2.0625 7.25238 2.09945 7.30755 2.14601 7.354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteUpArrow);
export default __webpack_public_path__ + "static/media/white-up-arrow.7d0dfc99910df088ac91567e05fdf210.svg";
export { ForwardRef as ReactComponent };